<template>
  <div class="news-deatils-conteng" ref="detailRef">
    <div class="title">{{ detailData.title }}</div>
    <div class="time">
      <span>{{ $t("news.releasedate") }}</span> :
      {{ detailData.releaseTime && detailData.releaseTime.replace(/-/g, "/") }}
    </div>
    <div
      class="detail-content"
      v-lazy-container="{selector: 'img'}"
      v-html="filterDeatilCss(detailData.details)"
    ></div>
  </div>
</template>

<script>
export default {
  name: "news",
  props: {
    msg: String,
  },
  data() {
    return {
      params: {
        page: 1,
        pageSize: 100,
        orders: { sequence: "desc" },
        param: {
          lang: "zh_CN",
        },
      },
      detailData: {},
    };
  },
  created() {
    if (this.$i18n.locale === "zh") {
      this.params.param.lang = "zh_CN";
    } else if (this.$i18n.locale === "en") {
      this.params.param.lang = "en";
    }
    if (Object.keys(this.$route.params).length) {
      window.localStorage.setItem(
        "detailData",
        JSON.stringify(this.$route.params)
      );
    }
  },
  mounted() {
    if (window.localStorage.getItem("detailData")) {
      this.detailData = JSON.parse(window.localStorage.getItem("detailData"));
    }
    this.$refs.detailRef.scrollTop = 0;
  },
  methods: {
    filterDeatilCss(detail) {
      if (detail) {
        detail = detail.replace(
          /\<img/g,
          '<img style="width:50rem;height:auto;margin-left: auto; margin-right: auto;display:block"'
        );
        detail = detail.replace(
          /\<span/g,
          '<span style="font-family: Alibaba PuHuiTi;font-size: 2rem;"'
        );
        detail = detail.replace(
          /src/g, "data-src"
        );
        return detail;
      }
    },
  },
  watch: {
    "$i18n.locale"(newValue) {
      if (newValue === "zh") {
        this.params.param.lang = "zh_CN";
      } else {
        this.params.param.lang = "en";
      }
    },
  },
};
</script>
<style lang="less" scoped>
.news-deatils-conteng {
  box-sizing: border-box;
  padding: 8rem 4rem 4.8rem 4rem;
  .title {
    font-size: 4rem;
    font-family: Alibaba PuHuiTi;
    font-weight: 500;
    color: #2b2b2b;
  }
  .time {
    box-sizing: border-box;
    padding-top: 3.2rem;
    font-size: 2rem;
    font-family: Alibaba PuHuiTi;
    font-weight: 400;
    color: #2b2b2b;
  }
  .detail-content {
    box-sizing: border-box;
    padding-top: 3rem;
    font-size: 2rem;
    font-family: Alibaba PuHuiTi;
    font-weight: 400;
    color: #2b2b2b;
  }
}
</style>
